import React from 'react'
import { ImageInt } from '../../../types/components'


export const Image: React.FC<ImageInt> = ({ src, alt, className, ...rest }) => (
  <img src={src} alt={alt} className={`inline-block mb-0 ${className}`} {...rest} loading="lazy" />
)

export default Image;
